@if(value) {
<div class="see-translation-label" (click)="translated ? seeOriginal() : seeTranslation()">
  {{ (translated ? 'label.see-original' : 'label.see-translation') | translate }}
</div>
}
